import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Select } from '../components/ui/Select';
import { Badge } from '../components/ui/Badge';
import { Network, Router, Wifi, Server } from 'lucide-react';
interface NetworkOverviewProps {
  onLogout: () => void;
}
export function NetworkOverview({
  onLogout
}: NetworkOverviewProps) {
  return <MainLayout title="Netzwerkübersichten" onLogout={onLogout} data-id="element-947">
      <div className="mb-6 w-full md:w-64" data-id="element-948">
        <Select options={[{
        value: '1',
        label: 'Müller GmbH - Hauptstandort'
      }, {
        value: '2',
        label: 'Schmidt KG - Filiale Nord'
      }]} data-id="element-949" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-950">
        {/* Network Info */}
        <div className="space-y-6" data-id="element-951">
          <Card title="Netzwerk Details" data-id="element-952">
            <div className="space-y-4" data-id="element-953">
              <div data-id="element-954">
                <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2" data-id="element-955">
                  WAN / Internet
                </h4>
                <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg" data-id="element-956">
                  <div className="flex items-center gap-2" data-id="element-957">
                    <Network className="h-4 w-4 text-slate-500" data-id="element-958" />
                    <span className="text-sm font-medium" data-id="element-959">
                      Telekom Glasfaser
                    </span>
                  </div>
                  <Badge variant="success" data-id="element-960">Online</Badge>
                </div>
              </div>

              <div data-id="element-961">
                <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2" data-id="element-962">
                  Subnetze
                </h4>
                <div className="space-y-2" data-id="element-963">
                  <div className="flex justify-between text-sm p-2 border border-slate-100 rounded" data-id="element-964">
                    <span data-id="element-965">Management</span>
                    <span className="font-mono text-slate-600" data-id="element-966">
                      192.168.1.0/24
                    </span>
                  </div>
                  <div className="flex justify-between text-sm p-2 border border-slate-100 rounded" data-id="element-967">
                    <span data-id="element-968">Clients</span>
                    <span className="font-mono text-slate-600" data-id="element-969">
                      192.168.10.0/24
                    </span>
                  </div>
                  <div className="flex justify-between text-sm p-2 border border-slate-100 rounded" data-id="element-970">
                    <span data-id="element-971">Gast-WLAN</span>
                    <span className="font-mono text-slate-600" data-id="element-972">
                      172.16.0.0/24
                    </span>
                  </div>
                </div>
              </div>

              <div data-id="element-973">
                <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2" data-id="element-974">
                  VLANs
                </h4>
                <div className="flex gap-2" data-id="element-975">
                  <Badge variant="outline" data-id="element-976">VLAN 1 (Mgmt)</Badge>
                  <Badge variant="outline" data-id="element-977">VLAN 10 (Office)</Badge>
                  <Badge variant="outline" data-id="element-978">VLAN 20 (VoIP)</Badge>
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Visual Diagram Placeholder */}
        <div className="lg:col-span-2" data-id="element-979">
          <Card title="Topologie" className="h-full min-h-[400px] flex items-center justify-center bg-slate-50" data-id="element-980">
            <div className="text-center" data-id="element-981">
              <div className="relative w-full max-w-lg mx-auto p-8 border-2 border-dashed border-slate-300 rounded-xl" data-id="element-982">
                {/* Simple CSS Diagram */}
                <div className="flex flex-col items-center gap-8" data-id="element-983">
                  <div className="p-4 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-984">
                    <Router className="h-8 w-8 text-red-500 mb-2" data-id="element-985" />
                    <span className="text-xs font-bold" data-id="element-986">
                      Firewall (Gateway)
                    </span>
                    <span className="text-[10px] text-slate-500" data-id="element-987">
                      192.168.1.1
                    </span>
                  </div>

                  <div className="h-8 w-0.5 bg-slate-300" data-id="element-988"></div>

                  <div className="p-4 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-989">
                    <Server className="h-8 w-8 text-blue-500 mb-2" data-id="element-990" />
                    <span className="text-xs font-bold" data-id="element-991">Core Switch</span>
                    <span className="text-[10px] text-slate-500" data-id="element-992">
                      192.168.1.2
                    </span>
                  </div>

                  <div className="relative w-full h-8" data-id="element-993">
                    <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-slate-300 -translate-x-1/2" data-id="element-994"></div>
                    <div className="absolute top-1/2 left-1/4 right-1/4 h-0.5 bg-slate-300" data-id="element-995"></div>
                    <div className="absolute top-1/2 left-1/4 h-4 w-0.5 bg-slate-300" data-id="element-996"></div>
                    <div className="absolute top-1/2 right-1/4 h-4 w-0.5 bg-slate-300" data-id="element-997"></div>
                  </div>

                  <div className="flex gap-12" data-id="element-998">
                    <div className="p-3 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-999">
                      <Wifi className="h-6 w-6 text-teal-500 mb-1" data-id="element-1000" />
                      <span className="text-xs font-bold" data-id="element-1001">AP Office</span>
                    </div>
                    <div className="p-3 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-1002">
                      <Wifi className="h-6 w-6 text-teal-500 mb-1" data-id="element-1003" />
                      <span className="text-xs font-bold" data-id="element-1004">AP Lager</span>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-sm text-slate-500 mt-4" data-id="element-1005">
                Interaktive Netzwerkkarte (Read-Only)
              </p>
            </div>
          </Card>
        </div>
      </div>
    </MainLayout>;
}